export const tryParseJson = (text?: string | null) => {
  try {
    return text ? JSON.parse(text) : null;
  } catch {
    // Silent fail - this is expected for non-JSON content like form names or HTML
    return null;
  }
};

export const tryParseJson2 = <E>(text: string, orElse: E): unknown | E => {
  try {
    return JSON.parse(text);
  } catch {
    return orElse;
  }
};

export const tryStringifyJson = (json?: object | null) => {
  try {
    return json ? JSON.stringify(json) : null;
  } catch (e) {
    console.error('error', e);
    return null;
  }
};
